var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5984 4.29897L15.5984 4.29899L15.6028 4.29618C15.9507 4.07356 16.1666 3.692 16.1666 3.27504C16.1666 2.31773 15.1229 1.75694 14.3217 2.24895L14.3217 2.24894L14.3182 2.25111L8.99996 5.57698L3.68174 2.25111L3.68175 2.2511L3.67826 2.24895C2.87698 1.75694 1.83329 2.31773 1.83329 3.27504C1.83329 3.692 2.04926 4.07356 2.3971 4.29618L2.39708 4.2962L2.40151 4.29897L7.84987 7.70627C7.85015 7.70645 7.85043 7.70663 7.85071 7.7068C8.55496 8.15057 9.44499 8.15056 10.1492 7.70679C10.1495 7.70662 10.1498 7.70644 10.15 7.70627L15.5984 4.29897ZM2.33329 0.833374H15.6666C16.3072 0.833374 16.8333 1.35952 16.8333 2.00004V12C16.8333 12.6406 16.3072 13.1667 15.6666 13.1667H2.33329C1.69277 13.1667 1.16663 12.6406 1.16663 12V2.00004C1.16663 1.35952 1.69277 0.833374 2.33329 0.833374Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhite);
export default __webpack_public_path__ + "static/media/email_white.cbfd79447d8d14202b414b595404e366.svg";
export { ForwardRef as ReactComponent };